import URLS from './urls'
import { AbstractAuth } from '@/dashboards/common'
import { AuthStore, Channel } from 'frontendcommon-3'
import * as Sentry from '@sentry/vue'
import axios from 'axios'
let JTI_TOKEN

export default class Auth extends AbstractAuth {
  onTokenUnauthorized () {
    this.redirectLogout()
  }

  async redirectLogin () {
    axios.create().get(`${URLS.LOGIN_URL}?token=${JTI_TOKEN}`).then(({ data }) => {
      AuthStore.removeTokenData()
      AuthStore.removeUserData()
      window.location.assign(data.redirect_url)
    })
  }

  async redirectLogout () {
    localStorage.removeItem('secured')
    return this.redirectLogin()
  }

  isSameToken (newToken) {
    return newToken === AuthStore.getToken()
  }

  validateToken (tokens) {
    try {
      if (!tokens?.token) return false
      if (!this.isSameToken(tokens.token)) AuthStore.storeTokenData(tokens)
    } catch {
      return false
    }
    return true
  }

  manageMarketplaceOverride ({ user }) {
    if ((
      user.customization_info.data.is_marketplace_override &&
      !window.location.pathname.includes('profile')
    )) {
      const nextTo = this.getNextTo()
      if (nextTo && !nextTo.to.path.includes('marketplace')) return
      window.location.assign(user.customization_info.data.link_logo_url)
      throw new Error('marketplace-override')
    }
  }

  getNextTo () {
    // When use this.loadNextTo(), localStorage is cleared, then if only you check if exist nexTo, you need use this method.
    const laa = window.localStorage.getItem(AuthStore.lastAccessKey)
    if (!laa) return false
    const nextTo = JSON.parse(laa)
    const diffMinutes = ((Date.now() - parseInt(nextTo.time)) / 60000)
    if (diffMinutes < 10) return nextTo
    return false
  }

  async getAuthData () {
    try {
      // get session data
      const tokens = await this.fetchToken()
      if (!this.validateToken(tokens.farmacloud)) throw new Error('Invalid token')
      // get shell config
      const { micros, sidebar } = await this.fetchShellConfig()
      const user = await this.fetchUserInfo()
      user.language = user.customization_info.data.language
      const authData = { isLogged: true, tokens, micros, sidebar, user }
      // Check if marketplace is override
      this.manageMarketplaceOverride(authData)
      // this.initSentry(authData)
      // this.initUsetiful(authData)
      return authData
    } catch (error) {
      if (error.message === 'marketplace-override') return
      console.error(error)
      return this.manageTokenError()
    }
  }

  async fetchToken () {
    try {
      const { data } = await axios.create().get(URLS.TOKEN_URL, { withCredentials: true })
      JTI_TOKEN = data?.jti
      return { farmacloud: data }
    } catch {
      JTI_TOKEN = null
      return false
    }
  }

  async refreshToken (prevTokens, tokenType) {
    try {
      const tokens = await this.fetchToken()
      this.validateToken(tokens?.farmacloud)
      // Emit token-changed-end
      Channel.emitTokenRefreshEnd({ tokenType, tokens: tokens.farmacloud })
    } catch (error) {
      this.redirectLogout()
      return false
    }
  }

  async fetchShellConfig () {
    let { data: micros } = await axios.get(`${URLS.SHELL_CONFIG_URL}?t=${Date.now()}`)
    // TODO: replace in shellcCofing
    micros = micros.map((micro) => ({ ...micro, id: micro.microId }))
    const mergedConfig = await this.mergeLocalConfig({ micros, sidebar: [], user: {} })
    return this.resolveActiveItem(mergedConfig)
  }

  async fetchUserInfo () {
    const { data } = await axios.create().get(`${URLS.USER_INFO_URL}?token=${JTI_TOKEN}`, { withCredentials: true })
    return data
  }

  initSentry (authData) {
    const { user } = authData
    Sentry.setUser({
      uuid: user.user_uuid,
      userName: [user.customization_info.data.user_first_name, user.customization_info.data.user_last_name].filter(Boolean).join(' '),
      userRole: user.customization_info.data.user_role_name,
      organizationName: user.customization_info.data.organization_name,
      language: user.customization_info.data.language,
      currentDelegation: user.current_delegation
    })
  }

  initUsetiful (authData) {
    if (typeof window.initUsetifull === 'function') {
      const { user } = authData
      Object.assign(window.usetifulTags, {
        language: user.customization_info.data.language,
        segment: user.segment,
        role: user.role,
        firstName: user.firstName,
        userId: user.userId,
        tagParentOrganization: user.parentOrganization
      })
      window.initUsetifull()
    }
  }

  async fetchDelegations (token) {
    const { data } = await axios.get(`/delegation/v1?token=${token}&has_profile=true`)
    return data
  }

  async switchDelegation (delegationUuid, token) {
    await axios.get(`/oauth/v1/switch/delegation/${delegationUuid}?token=${token}`)
  }
}
